'use strict';

import { ajaxWrapNew, ResponseDispatcher } from './ajaxWrapNew.js';
import { connMTUpdater } from './connMTUpdater.js';
import { autoSyncer } from './autoSyncer.js';
import { searchHistoryWin } from './searchHistoryWin.js';
import { VarMgr } from './VarMgr.js';
import { transGet } from './transTools.js';



function initConnectStatsCountryPage(connectSid, selectedCountry, addData) {
    /*
    on mouseenter palaižam taimeri un saglabājam kuram elementam tas ir;
    on mouseleave apturam taimeri un nodzēšam elementu;
    */
    var hoverTimer = null;
    var hoverElement = null;
    var hoverFixed = false;
    var hoverClicked = false;
    var leftOff;
    var leftWidth;
    var leftMax;
    const hoverTimerDelay = 500;
    const offsetX = 10;
    const $toolTip = $('<div class="statTooltip"></div>').css({
        display: 'block',
        opacity: 0.5,
        top: '-30px',
        left: '-30px',
        zIndex: -1
    }).appendTo('body');

    const toolTipGetHTML = function ($el) {
        const m1 = $el.data('m1');
        const m2 = $el.data('m2');
        const m3 = $el.data('m3');

        let html = [];
        let g = [];
        let c = [];

        html.push('<b>' + $el.data('count') + '</b>');
        html.push('<span class="cc">' + ($el.data('count') == 1 ? transGet('CONNECTEDvsk') : transGet('CONNECTEDdsk')) + '</span>');

        if (m2) {
            g.push('<span class="g2">W</span>');
            c.push('<span class="g1">' + m2 + '</span>');
        }
        if (m1) {
            g.push('<span class="g1">M</span>');
            c.push('<span class="g1">' + m1 + '</span>');
        }
        if (m3) {
            g.push('<span class="g3">A</span>');
            c.push('<span class="g1">' + m3 + '</span>');
        }

        html.push('<span class="mm">' + g.join('/ ') + '</span> <span class="mmc">' + c.join('/') + '</span>');

        return html.join('');
    };
    const show = function () {
        leftOff = $toolTip.offset().left;
        leftWidth = $toolTip.outerWidth();
        leftMax = leftOff + leftWidth;

        if (leftMax > $(window).width()) {
            leftMax = leftOff - leftWidth - (15 + offsetX);
            $toolTip.css({
                left: leftMax + 'px'
            });
        }
        $toolTip.css({
            opacity: 1,
            zIndex: 1
        });
    };
    const hide = function () {
        $toolTip.css({
            opacity: 0,
            zIndex: -1,
            top: '-30px',
            left: '-30px'
        });
    };
    const hideOther = function () {
        $('.statTooltip').not($toolTip).css({
            opacity: 0,
            zIndex: -1,
            top: '-30px',
            left: '-30px'
        });
    };

    var clickHoverClicked = false;
    $('.cnsGTb').on('click', '.clickHover', function () {
        //event.stopPropagation();
        $('.hoverClicked').removeClass('hoverClicked');
        $(this).addClass('hoverClicked');
        clickHoverClicked = true;

        $('.parent-hover-clicked').removeClass('parent-hover-clicked');
        $(this).closest('.i').addClass('parent-hover-clicked');
    });

    $('.cnsGTb').on('mouseenter', '.clickHover', function () {
        $('.parent-hover').removeClass('parent-hover');
        $(this).closest('.i').addClass('parent-hover');
    }).on('mouseleave', '.clickHover', function () {
        $('.parent-hover').removeClass('parent-hover');
    })

    $('.cnsGTb').on('mouseenter', '.hoverCount', function () {
        if (hoverClicked) {
            return;
        }

        hoverElement = this;
        $toolTip.html(toolTipGetHTML($(this)));
        hoverTimer = setTimeout(() => {
            hoverFixed = true;
            hideOther();
            show();
        }, hoverTimerDelay);
    }).on('mouseleave', '.hoverCount', function () {
        $('.parent-hover').removeClass('parent-hover');

        if (hoverClicked) {
            return;
        }
        clearTimeout(hoverTimer);
        hoverElement = null;
        hoverFixed = false;
        hide();
    }).on('mousemove', '.hoverCount', function (event) {
        if (hoverFixed || hoverClicked) {
            return;
        }
        $toolTip.css({
            top: event.pageY + 5,
            left: event.pageX + 5 + offsetX
        });
    }).on('click', '.hoverCount', function (event) {
        event.stopPropagation();

        hoverClicked = true;
        hoverFixed = true;
        if (hoverElement !== this) {
            hoverElement = this;
            $toolTip.html(toolTipGetHTML($(this)));
        }
        $toolTip.css({
            top: event.pageY + 5,
            left: event.pageX + 5 + offsetX
        });
        hideOther();
        show();
    });


    $('.city-list-opener').on('click', function (event) {
        event.stopPropagation();

        //new cityListWin(this, selectedCountry, addData);
        new searchHistoryWin(2, this, selectedCountry, addData);
    });

    $('.country-list-opener').on('click', function (event) {
        event.stopPropagation();

        new searchHistoryWin(1, this, 0, addData);
    });

    $('.cnsFtr').on('click', '.addnewloc', async function () {
        //event.stopPropagation();

        if ($(this).data('login')) {
            ajaxWrapNew({
                type: 'POST',
                data: {
                    ajax: 1,
                    action: 'gotoLogin',
                    saveback: 1
                },
                success: (data) => {
                    ResponseDispatcher.handle(data, 'toggleSwitch');
                },
                dataType: 'json'
            });
            return;
        }

        const miracleCityAddModal = await window.AppBridge.miracleCityAddModal();
        if (!miracleCityAddModal) {
            console.error('miracleCityAddModal not found');
            return;
        }
        miracleCityAddModal.init({
            isOnlySuggest: true,
            canSuggest: {ok: true, _fetchedAt: Date.now()},
            onSelect: (result) => {
                if (result && typeof result === 'object') {
                    if (result.newListItems) {
                        //miracleCityModal.insertCitiesAfter(result.newListItems, true);
                        //this.scrollDialog(0);
                    }
                }
            },
            onCantSuggest: (value) => {
                this.canSuggest = value;
            },
            onRemoveItem: (item) => {
                //return this.removeCity(item.city, item.country, item.favId);
            }
        });
    });

    $('.cnsFtr').on('click.cht', '.nv-switch-label', function (event) {
        if ($(event.target).closest('a').length) {
            return;
        }
        event.stopPropagation();

        let needLogin = false;
        const switchEl = $(this).find('.nv-switch');
        if (switchEl.data('login')) {
            needLogin = true;
        }
        let el = $(this).find('.nv-switch').get(0),
            on = $(el).first().hasClass('on') || needLogin ? false : true;
        $(el).toggleClass('on', on).toggleClass('off', !on);


        ajaxWrapNew({
            type: 'POST',
            data: {
                ajax: 1,
                action: 'toggleSwitch',
                on: on ? 1 : 0,
                key: switchEl.data('key'),
                country: switchEl.data('country'),
                location: switchEl.data('location'),
                needLogin: needLogin ? 1 : 0
            },
            success: (data) => {
                ResponseDispatcher.handle(data, 'toggleSwitch');
            },
            dataType: 'json'
        });
    });

    $(window).on('jq-outclick', function (event) {
        if (hoverClicked) {
            hoverClicked = false;
            hoverFixed = false;
            hide();
        }
        if (clickHoverClicked) {
            clickHoverClicked = false;
            $('.hoverClicked').removeClass('hoverClicked');
            $('.parent-hover-clicked').removeClass('parent-hover-clicked');
        }
    });


    var $connMT = $('.connMTSC');
    var connUpdater = new connMTUpdater({
        'selector': '.connMTSC'
    });
    //window['connUpdater'] = connUpdater;

    autoSyncer.setGlobal('connectSID', connectSid);
    autoSyncer.setGlobal('selectedCountry', selectedCountry);
    if (addData) {
        if (addData.selectedCity) {
            autoSyncer.setGlobal('selectedCity', addData.selectedCity);
        }
        if (addData.selectedRegion1) {
            autoSyncer.setGlobal('selectedRegion1', addData.selectedRegion1);
        }
        if (addData.selectedRegion2) {
            autoSyncer.setGlobal('selectedRegion2', addData.selectedRegion2);
        }
    }
    autoSyncer.add('stat-counter-country', selectedCountry, {
        counter: $connMT.data('cnt')
    }, function (itemData) {
        if (itemData.counterTT) {
            connUpdater.updateTitle(itemData.counterTT);
        }
        if (itemData.counter !== undefined) {
            $('.connM0').text(itemData.counter);
            $('.connM1').text(itemData.counterM1);

            if ($connMT.data('cnt') != itemData.counter) {
                $connMT.data('cnt', itemData.counter);
                connUpdater.update(itemData.connMT, itemData.counter);
            }

            return {
                counter: itemData.counter
            };
        }
        return false;
    });
}

/* function cityListWin(opener, selectedCountry, addData) {
    const self = this;

    if ($('.citylistwin').length) {
        // @ts-ignore
        if ($('.citylistwin').get(0).cityListWin) { $('.citylistwin').get(0).cityListWin.open(opener); return; }
    }
    /* $('.citylistwin').each(function() {
        // @ts-ignore
        if (this.cityListWin) { this.cityListWin.close(); }
    }); *-/


    this.$overlay = $('<span class="overlayOutclicker citylist"></span>');
    this.$citylist = $('<div class="citylistpop"></div>');
    this.$container = $('<div class="citylistwin"></div>');
    this.$calcTarget = $('.cnsGTb').first();
    this.created = false;
    this.nextoffset = 0;
    this.perpage = 20;

    this.isselect = true;
    this.searchTitle = transGet('stSearchTitle');

    this.create = function () {
        if (this.created) {
            return;
        }
        this.created = true;

        const html = `
            <div class="in">
                <div class="stickytopstats">
                    <div class="top">
                        <div class="head">
                            <a class="country" href="#"></a>
                            <div class="stats"></div>
                        </div>
                        <form class="search-city-frm" action="/" method="get">
                            <input type="hidden" name="cityid" value="">
                            <input type="hidden" name="citystr" value="">
                            <select class="citySearchSel" name="citysearchsel" data-prev="" data-dropdown-css-class="citysearch-select-dropdown" data-selection-css-class="citysearch-select" autocomplete="off">
                                <option value="">${self.searchTitle}</option>
                            </select>
                            <button class="searchbutton" type="submit"></button>
                        </form>
                    </div>
                </div>
                <div class="lists">
                    <div class="list">

                    </div>
                    <div class=""><button class="loadMoreCities" type="button" title="Load More"></button></div>
                </div>
            </div>
        `;

        self.$citylist.append(html);
        self.$container.append(self.$overlay).append(self.$citylist);
        $('body').append(self.$container);

        self.$citylist.find('.country').attr('href', addData.urlCountry || '#').html(addData.countryTitle || '');

        // @ts-ignore
        self.$container.get(0).cityListWin = self;


        self.$overlay.on('click', function () {
            self.close();
        });

        self.$citylist.on('click', 'a', function (event) {
            let url = $(this).attr('href');
            if (url.indexOf('javascript') === 0) {
                return;
            }
            event.preventDefault();
            self.saveView();
            appState.historyInstance.afterPopstate = function () {
                setTimeout(function () {
                    window.location.assign(url);
                }, 20);
                return false;
            };
            self.close();
        });

        self.$citylist.on('click', '.loadMoreCities', function (event) {
            self.loadNextCities();
        });

        if (self.isselect) {
            var $searchField = self.$citylist.find('.citySearchSel');
            $searchField.select2({
                dropdownAutoWidth: true,
                width: '100%',
                placeholder: self.searchTitle,
                allowClear: true,
                minimumInputLength: 2,
                tags: true, // Iespējo brīvo tekstu
                ajax: {
                    //url: ajaxUrlSearch,
                    method: 'POST',
                    dataType: 'json',
                    delay: 250,
                    data: function (params) {
                        return {
                            ajax: 1,
                            action: 'loadCitiesSelect',
                            selectedCountry: selectedCountry,
                            q: params.term, // search term
                            qp: params.page
                        };
                    },
                    processResults: function (data, params) {
                        params.page = params.page || 1;
                        return {
                            results: data.results,
                            pagination: {
                                more: data.more ? true : false
                            }
                        };
                    },
                    cache: true
                },
                createTag: function (params) {
                    var term = $.trim(params.term);
                    if (term === '') { return null; }
                    return {
                        id: term, // ID ir pats teksts!
                        text: term, // Teksts, ko redz izvēlnē augšā
                        isNew: true // Pazīme mums pašiem
                    };
                },
                insertTag: function (data, tag) {
                    data.unshift(tag);
                }
            });

            $searchField.on('select2:select', function (e) {
                var data = e.params.data;

                // @ts-ignore
                if (data.isNew) {
                    if ($searchField.data('prev') === data.id) {
                        return;
                    }
                    $searchField.data('prev', data.id);

                    $searchField.val(data.id);
                    self.$citylist.find('input[name="cityid"]').val('');
                    self.$citylist.find('input[name="citystr"]').val(data.id);
                    self.$citylist.find('.search-city-frm').submit();

                } else {
                    var text = data.text;
                    ajaxWrapNew({
                        method: 'POST',
                        data: {
                            ajax: 1,
                            action: 'loadCityInfo',
                            selectedCountry: selectedCountry,
                            selectedCity: data.id
                        },
                        success: function (data) {
                            ResponseDispatcher.handle(data, 'loadCityInfo');
                            if (data.url) {
                                self.$citylist.find('input[name="cityid"]').val(data.cityid);
                                self.$citylist.find('input[name="citystr"]').val(text);
                                self.saveView();
                                appState.historyInstance.afterPopstate = function () {
                                    setTimeout(function () {
                                        window.location.assign(data.url);
                                    }, 20);
                                    return false;
                                };
                                self.close();
                            }
                        },
                        dataType: 'json'
                    });
                }
            });

            $searchField.on('select2:clear', function () {
                $searchField.data('prev', '');
                $searchField.data('blockOpen', true);

                $searchField.val('');
                self.$citylist.find('input[name="cityid"]').val('');
                self.$citylist.find('input[name="citystr"]').val('');
                self.$citylist.find('.search-city-frm').submit();
            });

            $searchField.on('select2:opening', function (e) {
                if ($searchField.data('blockOpen')) {
                    $searchField.data('blockOpen', false);
                    e.preventDefault();
                }
            });
        }

        self.$citylist.on('submit', '.search-city-frm', function (event) {
            event.preventDefault();

            self.searchCities(self.$citylist.find('input[name="citystr"]').val());
        });

        $(window).on('jq-resize-end', function (event, w) {
            if (self.$container.is('.opened')) {
                self.setPosition();
            }
        });

        // @ts-ignore
        if (typeof window.citylistRegistered === 'undefined') {
            // @ts-ignore
            window.citylistRegistered = true;
            appState.historyInstance.add('citylist', {
                value: null,
                backCallback: function (change) {
                    try {
                        // @ts-ignore
                        if ($('.citylistwin').get(0)?.cityListWin) { $('.citylistwin').get(0).cityListWin.close(true); }
                    } catch (e) {

                    }
                },
                checkCallback: function (value) {
                    if ($('.citylistwin').length) {
                        try {
                            if ($('.citylistwin').is('.opened')) {
                                return true;
                            }
                        } catch (e) {

                        }
                    }
                    return null;
                },
                goBackOnRefresh: true
            });
        }
    };

    self.saveView = function () {
        const data = {
            country: selectedCountry,
            scroll: $(window).scrollTop(),
            search: self.$citylist.find('input[name="citystr"]').val(),
            cityid: self.$citylist.find('input[name="cityid"]').val(),
            nextoffset: self.nextoffset
        };
        sessionStorage.setItem('cityListWin', JSON.stringify(data));
    };

    self.setPosition = function () {
        const offset = self.$calcTarget.offset();
        const width = self.$calcTarget.width();
        self.$citylist.css({
            top: offset.top,
            left: offset.left - 10,
            width: width + 10
        });
    };

    self.show = function () {
        self.$container.addClass('opened');
    };

    self.hide = function () {
        self.$container.removeClass('opened');
    };

    self.searchCities = function (searchString) {
        console.log(searchString);
        setUrlParam('citystr', searchString);

        self.$citylist.find('.list').empty();
        self.loadCities(null, false, 0).then(() => {
            self.setPosition();
            self.show();
        }).catch(() => {
            self.setPosition();
            self.show();
        });
    };

    self.loadNextCities = function () {
        // todo loading;
        self.loadCities().then(() => {
            self.setPosition();
            self.show();
        }).catch(() => {
            self.setPosition();
            self.show();
        });
    };

    self.loadCities = async function (opener, loadFromStart = false, offset = null) {
        return ajaxWrapNew({
            method: 'POST',
            data: $.extend({
                ajax: 1,
                action: 'loadCities',
                offset: offset !== null ? offset : self.nextoffset,
                selectedCountry: selectedCountry,
                loadFromStart: loadFromStart ? 1 : 0,
                searchString: self.$citylist.find('input[name="citystr"]').val()
            }, addData),
            success: function (data) {
                self.addCities(data);
            },
            dataType: 'json'
        });
    };

    self.addCities = function (data) {
        self.$citylist.find('.loadMoreCities').toggle(data.more);
        self.nextoffset = data.nextoffset;
        const $list = self.$citylist.find('.list');

        if (data.countryStats && (data.countryStats?.connections || data.countryStats?.miracles)) {
            self.$citylist.find('.stats').html(data.countryStats.connections + '<span class="sep10">/</span>' + data.countryStats.miracles);
        } else {
            self.$citylist.find('.stats').empty();
        }

        $.each(data.list, function (i, city) {
            $list.append('<a href="' + city[3] + '"><span>' + city[0] + '</span> <span>' + (city[1] || city[2] ? city[1] + '<span class="sep">/</span>' + city[2] : '') + '</span></a>');
        });
    };

    self.open = function (opener, nohistory) {
        self.create();

        if (!nohistory) {
            appState.historyInstance.push('citylist');
        }
        if (self.nextoffset) {
            self.setPosition();
            self.show();
            return;
        }
        var savedCityDataStr = sessionStorage.getItem('cityListWin');
        var savedCityData = null;
        var loadFromStart = false;
        if (savedCityDataStr) {
            try {
                savedCityData = JSON.parse(savedCityDataStr) || {};
                if (savedCityData.country != selectedCountry || (opener && $(opener).data('type') == 'country')) {
                    // dzēšam laukā ? vai vienkārši nelietojam
                    sessionStorage.removeItem('cityListWin');
                } else if (savedCityData.nextoffset) {
                    self.nextoffset = savedCityData.nextoffset - self.perpage;
                    loadFromStart = true;
                    self.$citylist.find('input[name="citystr"]').val(savedCityData.search || '');
                    self.$citylist.find('input[name="cityid"]').val(savedCityData.cityid || '');

                    self.$citylist.find('.citySearchSel').each(function () {
                        $(this).append($('<option selected></option>').attr('value', savedCityData.cityid || savedCityData.search || '').text(savedCityData.search || ''));
                    });
                }
            } catch (e) {
                savedCityData = null;
            }
        }
        self.loadCities(opener, loadFromStart).then(() => {
            self.setPosition();
            self.show();
            if (savedCityData) {
                setTimeout(function () {
                    setScroll(savedCityData.scroll);
                }, 20);
            }
        }).catch(() => {
            self.setPosition();
            self.show();
        });
    };

    self.close = function (nohistory) {
        if (!nohistory && (typeof appState.historyInstance != 'undefined') && appState.historyInstance) {
            appState.historyInstance.go(-1);
            return;
        }

        self.hide();
    };


    self.open(opener);
} */


export function loadConnectStatsDetailed() {
    const statsData = VarMgr.get('statsData');
    if (!statsData || !statsData.isDetailed) {
        return;
    }

    initConnectStatsCountryPage(statsData.connectSid, statsData.selectedCountry, {
        selectedCity: statsData.selectedCity || null,
        selectedRegion1: statsData.selectedRegion1 || null,
        selectedRegion2: statsData.selectedRegion2 || null,
        urlCountry: statsData.urlCountry,
        countryTitle: statsData.countryTitle
    });
}
